import authInstance from './authInstance'

const getSubscriptions = async () => {
  const response = await authInstance.get('/admin/webhooks/subscriptions')
  return response.data
}

const createSubscription = async (data) => {
  const response = await authInstance.post('/admin/webhooks/subscriptions/create', data)
  return response.data
}

const updateSubscription = async (id, data) => {
  const response = await authInstance.post(`/admin/webhooks/subscriptions/update/${id}`, data)
  return response.data
}

const deleteSubscription = async (id) => {
  const response = await authInstance.delete(`/admin/webhooks/subscriptions/${id}`)
  return response.data
}

const getDeliveries = async (subscriptionId) => {
  const response = await authInstance.get(`/admin/webhooks/subscriptions/${subscriptionId}/deliveries`)
  return response.data
}

const testSubscription = async (id, body) => {
  const response = await authInstance.post(`/admin/webhooks/subscriptions/${id}/test`, body)
  return response.data
}

const retryDelivery = async (deliveryId) => {
  const response = await authInstance.post(`/admin/webhooks/deliveries/${deliveryId}/retry`)
  return response.data
}

export const webhookService = {
  getSubscriptions,
  createSubscription,
  updateSubscription,
  deleteSubscription,
  getDeliveries,
  testSubscription,
  retryDelivery,
}
